import type { ReactElement } from "react";
import humanBadgeIcon from "./HumanBadgeIcon.svg";

export function HumanBadgeIcon(): ReactElement {
  return <img alt="" src={humanBadgeIcon} width={32} height={32} />;
}
